import { render } from "./lyqrcode.vue?vue&type=template&id=2cfca8ad"
import script from "./lyqrcode.vue?vue&type=script&lang=js"
export * from "./lyqrcode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__